module.exports = __webpack_public_path__ + "img/6_109.5390d4a1.png";